import React from 'react';
import BaseProps from "../../../types/BaseProps";
import PageSizeSelector from "./PageSizeSelector";
import {Results} from "../../../types/Search";
import classNames from "classnames";

import "./SearchToolbar.scss";

type SearchToolbarProps = BaseProps & {
  onPageSizeChange: (size: number) => void;
  disabled: boolean
  data: Results;
  from: number;
};

/**
 * Wrapper component for search toolbar. The toolbar can contain a list of tools.
 */
class SearchToolbar extends React.Component<SearchToolbarProps> {

  render() {
    const data: Results = this.props.data;
    if (data.total < 1) {
      return null;
    }

    const classes = classNames("SearchToolbar", this.props.className);
    return (
      <div className={classes}>
        <ResultsCount from={this.props.from} count={data.count} total={data.total}/>
        <PageSizeSelector disabled={this.props.disabled}
                          onPageSizeChange={this.props.onPageSizeChange}/>
      </div>
    );
  }

}

function ResultsCount(props: { from: number, count: number, total: number }) {
  const rangeStart = props.from + 1;
  const rangeEnd = props.from + props.count;
  return (
    <span className="ResultsCount py-1 text-muted">
      Showing {rangeStart} - {rangeEnd} of {props.total} results
    </span>
  );
}

export default SearchToolbar;
